module.exports = require('./helpers/bundle-url').getBundleURL('glOsZ') + "signin.49105d33.jpg";